import { css } from "@emotion/react";
import { Theme } from "@mui/material";

export const popoutMenuWithCaretStyles = (theme: Theme) => {
  return css({
    ".MuiPaper-root": {
      overflow: "visible",
      margin: "0.15rem",

      "&:before": {
        content: `""`,
        display: "block",
        position: "absolute",
        top: 0,
        right: 14,
        width: 10,
        height: 10,
        backgroundColor: theme.palette.background.paper,
        backgroundImage: "inherit",
        transform: "translateY(-50%) rotate(45deg)",
        zIndex: 0,
      },
    },
  });
};
